<ng-template #dialogBody let-data>
  <div class="title-popup-1">
    <div class="d-flex align-items-center justify-content-between">
      <div class="title-text">{{ 'add_new_category' | translate }}</div>
      <i class="icon-close cursor-pointer" (click)="close()"></i>
    </div>
  </div>
  <app-select-outlet *ngIf="step === 1" (goNext)="goNext()"></app-select-outlet>
  <app-select-outlet-activation
    *ngIf="step === 2"
    (goNext)="goNext()"
    (goPrev)="goPrev()"
  ></app-select-outlet-activation>
  <app-select-outlet-activation-result
    *ngIf="step === 3"
    (goNext)="goNext()"
    (selectOutlet)="selectOutlet()"
  ></app-select-outlet-activation-result>
</ng-template>
